<template>
  <a-modal
    v-model:visible="modal.show"
    okText="提交"
    :closable="false"
    @ok="handleOk"
    destroyOnClose
    :confirm-loading="modal.submitLoading"
    class="modalFormCollection"
  >
    <div class="tip">
      <div class="tip_title">与星汉未来联系</div>
      <div class="tip_text">留下您的联系方式，我们将在1个工作日内和您联系</div>
    </div>
    <a-row>
      <a-col :xs="24" :lg="24">
        <a-form
          ref="form"
          :model="form.data"
          :rules="form.rule"
          name="FormCollection"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
          :layout="
            $Store.Public().isGridMatch('>=', $Enum.GridEnum.MD)
              ? 'horizontal'
              : 'vertical'
          "
        >
          <a-form-item name="real_name" has-feedback label="姓名">
            <a-input
              v-model:value="form.data.real_name"
              placeholder="请填写姓名"
              :maxlength="$Check.Constraint.RealNameMax"
              :show-count="form.data.real_name.length > 0"
              allow-clear
            >
              <!-- <template #prefix>
                <IdcardOutlined class="input_icon" />
              </template> -->
            </a-input>
          </a-form-item>
          <a-form-item name="telphone" has-feedback label="手机号">
            <a-input
              v-model:value="form.data.telphone"
              placeholder="请填写手机号"
              :maxlength="$Check.Constraint.Phone"
              :show-count="form.data.telphone.length > 0"
              allow-clear
            >
              <!-- <template #prefix>
                <TeamOutlined class="input_icon" />
              </template> -->
            </a-input>
          </a-form-item>
          <a-form-item name="email" has-feedback label="邮箱">
            <a-input
              v-model:value="form.data.email"
              placeholder="请填写邮箱"
              allow-clear
            >
              <!-- <template #prefix>
                <TeamOutlined class="input_icon" />
              </template> -->
            </a-input>
          </a-form-item>
          <a-form-item name="ent_name" has-feedback label="企业/学校">
            <a-input
              v-model:value="form.data.ent_name"
              placeholder="请填写企业/学校"
              :maxlength="$Check.Constraint.MaxX"
              :show-count="form.data.ent_name.length > 0"
              allow-clear
            >
              <!-- <template #prefix>
                <TeamOutlined class="input_icon" />
              </template> -->
            </a-input>
          </a-form-item>
          <a-form-item name="position" has-feedback label="职位">
            <a-input
              v-model:value="form.data.position"
              placeholder="请填写职位"
              :maxlength="$Check.Constraint.MaxX"
              :show-count="form.data.position.length > 0"
              allow-clear
            >
              <!-- <template #prefix>
                <SolutionOutlined class="input_icon" />
              </template> -->
            </a-input>
          </a-form-item>
          <a-form-item name="description" label="需求描述">
            <a-textarea
              v-model:value="form.data.description"
              placeholder="请填写需求描述"
              :maxlength="$Check.Constraint.Max4X"
              :show-count="true"
              allow-clear
            >
            </a-textarea>
          </a-form-item>
          <a-form-item name="other" label="其他">
            <a-textarea
              v-model:value="form.data.other"
              placeholder="请填写其他"
              :maxlength="$Check.Constraint.Max4X"
               :show-count="true"
              allow-clear
            >
            </a-textarea>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script lang="ts" type="text/tsx">
import { DataInterface } from '_Project/application/interface/public'
export default {
  name: 'page_modalFormCollection',
  data(): DataInterface {
    return {
      modal: {
        show: false,
        submitLoading: false,
      },
      expand: {
        current: '',
        type: {
          freeUse: $Enum.TextEnum.OperateFreeUse,
          reserve: $Enum.TextEnum.OperateReserve,
          deployment: '点击预约私有化部署按钮',
          demo: '点击预约咨询按钮',
          demoCostPilot:'点击预约咨询(CostPilot)按钮',
          learnMore:'点击Serverless解决方案按钮',
          freeUseCostPilot:'点击免费体验(CostPilot)按钮',
          demoCustomerCases:'点击预约咨询(客户案例)按钮',
          productAidigitalHuman:'点击互动数字人平台(SaaS)联系我们按钮',
          productPrivateAidigitalHuman:'点击互动数字人平台(私有化)预约技术演示按钮',
          productPrivateAidigitalHumanGetPlan:'点击互动数字人平台(私有化)立即获取方案按钮'
        },
      },
      form: {
        rule: {
          real_name: $Check.Rule.RealName(),
          ent_name: ((name: string) => [
            $Check.Rule.Required(name),
            $Check.Rule.Length(
              name,
              $Check.Constraint.Min,
              $Check.Constraint.MaxX
            ),
          ])('企业/学校'),
          position: ((name: string) => [
            // $Check.Rule.Required(name),
            $Check.Rule.Length(
              name,
              $Check.Constraint.Min,
              $Check.Constraint.Max
            ),
          ])('职位'),
          telphone: $Check.Rule.Phone(),
          email: $Check.Rule.Mail(),
          description: ((name: string) => [
            // $Check.Rule.Required(name),
            $Check.Rule.Length(name, 0, $Check.Constraint.Max7X),
          ])('需求描述'),
          other: ((name: string) => [
            // $Check.Rule.Required(name),
            $Check.Rule.Length(name, 0, $Check.Constraint.Max7X),
          ])('其他'),
        },
        data: {
          real_name: '',
          ent_name: '',
          position: '',
          email: '',
          telphone: '',
          description: '',
          other: '',
        },
      },
    }
  },
  mounted() {},
  methods: {
    async handleOk(event: any) {
      let data = this.form.data
      // console.log(`${this.expand.type[this.expand.current]},
      //   用户姓名:${data.real_name},
      //   手机号:${data.telphone},
      //   企业/学校:${data.ent_name},
      //   职位:${data.position},
      //   需求描述:${data.description},
      //   其他：${data.other}`)
      await this.$refs.form
        .validateFields()
        .then(async () => {
          this.modal.submitLoading = true
          await $RQ.PushWebHook(
            $Store.User().username,
        `${this.expand.type[this.expand.current]},
          用户姓名:${data.real_name},
          手机号:${data.telphone},
          邮箱:${data.email},
          企业/学校:${data.ent_name},
          职位:${data.position},
          需求描述:${data.description},
          其他：${data.other}`
          )
          this.modal.submitLoading = false
          this.close()
          $FN.Message('success', {
            content: '提交成功',
          })
        })
        .catch(() => {
          $FN.Message('warning', {
            content: $Enum.TextEnum.ErrorCheckFail,
          })
        })
    },
    /**
     * 打开
     * @param {string} type 类型
     */
    open(type: string): void {
      this.modal.show = true
      this.expand.current = type
      this.form.data ={
        real_name: '',
          ent_name: '',
          position: '',
          email: '',
          telphone: '',
          description: '',
          other: '',
      }
    },

    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false
      this.expand.current = ''
    },
    onFinish(values: any) {
      console.log('Success:', values)
    },
    onFinishFailed(errorInfo: any) {
      console.log('Failed:', errorInfo)
    },
  },
}
</script>
<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';
.tip {
  &_title {
    .font(justify, @title_mo, @color_13, @title_mo);
    margin: 20px 0;
  }
  &_text {
    .font(justify, @text, @color_13, @text);
    margin: 20px 0;
  }
}
.ant-form-item {
  @radius: 8px;
  .ant-form-item-label {
    .font(right, @text, @color_13, @text);
  }
}
.modalFormCollection{
  height: max-content !important;
  top: 20px !important;
}
@media screen and (max-width: -1px+@grid_md) {
  .tip {
    &_title {
      .font(justify, @title_mo, @color_13, @title_mo);
      margin: 10px 0;
    }
    &_text {
      .font(justify, @text_big, @color_13, @text_mo);
      margin: 10px 0;
    }
  }
  .ant-form-item {
    @radius: 8px;
    .ant-form-item-label {
      .font(left, @text, @color_13, @text);
    }
  }
}
</style>
